import styled from 'styled-components';

export const PageFormBox = styled.div`
  background-color: #fff;
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  width: 100%;
  padding: 20px;
`;
